import { getDataWithQueryString, postData } from "./componentAPIs";
import { HTTP_METHOD } from "../appConstants";
const axiosConfig = {
  timeout: 60000
};

const sendRequestWithDeduplication = (() => {
    // Cache for storing pending requests
    let requestCache = {};
    return (method, apiName, queryParams, getLatestQuery, abortSignal = null) => {
      // Create a unique cache key based on the URL and request options
      const uniqueAPINameKey = apiName;
      // Check if there is a pending request for the same URL and options
      if (requestCache[uniqueAPINameKey]?.pending) {
        // Reject next request's promise if exists else mark current request as next request and return the promise.
        const nextRequest = requestCache[uniqueAPINameKey]?.nextRequest;
        if (nextRequest?.promiseReject) {
          nextRequest?.promiseReject("Stale request. Cancelled");
        }
        let [promiseResolve, promiseReject] = [null, null];
  
        const nextRequestPromise = new Promise((resolve, reject) => {
          promiseResolve = resolve;
          promiseReject = reject;
        });
        requestCache[uniqueAPINameKey].nextRequest = {
          method,
          apiName,
          queryParams,
          promiseResolve,
          promiseReject,
          getLatestQuery,
          abortSignal,
        };
        return nextRequestPromise;
      }
      
      // Cache the request
    requestCache[uniqueAPINameKey] = { pending: true, nextRequest: null };
     return new Promise((resolve, reject) => {
      let nextRequest = null;
       // Wait for the request to resolve
       const latestQueryString = getLatestQuery ? getLatestQuery() : queryParams;
       
       // Merge axiosConfig with abort signal if provided
       const requestConfig = abortSignal ? { ...axiosConfig, signal: abortSignal } : axiosConfig;
       
       const requestPromise =
        method === HTTP_METHOD.GET
          ? getDataWithQueryString(apiName, latestQueryString, requestConfig)
          : postData(apiName, latestQueryString, requestConfig);
        requestPromise.then((response) => {
          nextRequest = requestCache[uniqueAPINameKey].nextRequest;
          delete requestCache[uniqueAPINameKey];
          resolve(response)
        }).catch(err=>{
            // Remove the request from the cache
            delete requestCache[uniqueAPINameKey];
            reject(err);
        }).finally(()=>{
          // process next request once pending request promise is settled
          if (nextRequest) {
            return sendRequestWithDeduplication(
              nextRequest.method,
              nextRequest.apiName,
              nextRequest.queryParams,
              nextRequest.getLatestQuery,
              nextRequest.abortSignal
            )
              .then((response) => {
                nextRequest.promiseResolve(response);
              })
              .catch((error) => {
                nextRequest.promiseReject(error);
              });
          }
        });
    });
    };
  })();

export default sendRequestWithDeduplication;